import styled from "styled-components"

const visible = `
  visibility: visible;
  opacity: 1;
  transform: translateX(0);
`
const hidden = `
  visibility: hidden;
  opacity: 0;
  transform: translateX(-15px);
`

const Item = styled.div`
  ${(props) => (props.index === props.activeIndex ? visible : hidden)};
  transition: transform 1s ease-out, opacity 1s ease-out;
  color: currentColor;
  grid-area: content;
  // these props.styles are defined where BlockCarousel is called
  ${(props) => props.styles}
`

export default function CarouselItem(props) {
  return <Item {...props}>{props.item}</Item>
}
